import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { HandHeart, X } from "lucide-react";

export const NudgeBanner = () => {
  const [nudges, setNudges] = useState([]);
  useEffect(() => { api.get("/nudges").then((r) => setNudges(r.data)).catch(() => {}); }, []);
  if (!nudges.length) return null;
  const n = nudges[0];
  const dismiss = async () => {
    setNudges([]);
    await Promise.all(nudges.map((x) => api.post(`/nudges/${x.id}/dismiss`))).catch(() => {});
  };
  return (
    <section data-testid="nudge-banner"
      className="relative border-l-2 border-accent bg-accent/[0.06] px-6 py-5 flex items-start gap-4 animate-in fade-in slide-in-from-top-2 duration-500">
      <HandHeart className="w-5 h-5 text-accent mt-1 shrink-0" />
      <div className="flex-1">
        <p className="font-serif text-lg leading-relaxed" data-testid="nudge-banner-text">
          {n.from_name} from <span className="italic">{n.group_name}</span> is thinking of you.
        </p>
        <p className="text-sm text-muted-foreground mt-1">
          Whenever you're ready, take a few quiet minutes for your Starting Assessment. No pressure, just an open door.
        </p>
        <Link to="/app/assessment/start" data-testid="nudge-banner-cta"
          className="inline-block mt-3 text-sm text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
          Take it now
        </Link>
      </div>
      <button onClick={dismiss} data-testid="nudge-banner-dismiss" title="Dismiss"
        className="text-muted-foreground hover:text-foreground transition-colors">
        <X className="w-4 h-4" />
      </button>
    </section>
  );
};
